import { Box, SxProps, Theme, Typography } from '@mui/material';

import { useLanguage } from '../../hooks';
import { DocWithMagnifyingGlassIllustration } from '../../illustrations';

const customStyles: Record<string, SxProps<Theme>> = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '32px 0px',
    marginTop: '80px',
  },
  illustration: {
    width: '167px',
    height: '167px',
  },
  text: {
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: 400,
    color: (theme) => theme.palette.common.black,
    lineHeight: '22px',
    marginTop: '32px',
  },
};

export const EmptyDynamicSignatureQuestionsState = () => {
  const lang = useLanguage();
  const message = lang.formSignatureBuilder.noDynamicSignatureQuestionsAvailable;

  return (
    <Box sx={customStyles.root}>
      <DocWithMagnifyingGlassIllustration sx={customStyles.illustration} />
      <Typography sx={customStyles.text}>
        {message.split('\n').map((line, index) => (
          <span key={index}>
            {line}
            {index < message.split('\n').length - 1 && <br />}
          </span>
        ))}
      </Typography>
    </Box>
  );
};
